const createCookieString = (cookieObject: Record<string, string | null>) => {
  const cookies = Object.entries(cookieObject).reduce(
    (cookies, [key, value]) => {
      return value ? `${cookies}${key}=${value}; ` : cookies;
    },
    "",
  );

  if (cookies.length === 0) return "";

  return cookies.slice(0, cookies.length - 2);
};

export default createCookieString;
